export default "__VITE_ASSET__c625eef3__"